
import { defineComponent } from "vue";

export default defineComponent({
  name: "CiUspComponent",

  props: {
    headingType: {
      type: String,
      default: "h2",
    },
  },

  setup() {
    const uniqueSellingPoints: ContentHubs.UniqueSellingPoint[] = [
      { text: "ui.components.base.capinside_usp.usp_0", icon: "mdi-trending-up" },
      { text: "ui.components.base.capinside_usp.usp_1", icon: "mdi-chart-areaspline" },
      { text: "ui.components.base.capinside_usp.usp_2", icon: "mdi-text-box" },
      { text: "ui.components.base.capinside_usp.usp_3", icon: "mdi-account-search" },
      { text: "ui.components.base.capinside_usp.usp_4", icon: "mdi-message-text" },
    ];

    return {
      uniqueSellingPoints,
    };
  },
});
